import { render, staticRenderFns } from "./orderPage.vue?vue&type=template&id=5b2e1578&"
import script from "./orderPage.vue?vue&type=script&lang=ts&"
export * from "./orderPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports